/* Sherrys footer: small interactions only; mobile menus use native <details>. */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.shfReady === 'true') return;
    root.dataset.shfReady = 'true';
    var top = root.querySelector('[data-shf-top]');
    if (top) top.addEventListener('click', function () {
      window.scrollTo({ top:0, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth' });
    });
    var country = root.querySelector('[data-shf-country]');
    if (country) country.addEventListener('change', function () { if (country.form) country.form.submit(); });
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var targets = root.querySelectorAll('[data-shf-reveal]');
    if (!targets.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('shf--visible');
        observer.unobserve(entry.target);
      });
    }, { threshold:0.03, rootMargin:'0px 0px 100px 0px' });
    targets.forEach(function (target) { observer.observe(target); });
    root.classList.add('shf--enhanced');
  }
  function initAll(scope) {
    if (scope.matches && scope.matches('[data-shf-footer]')) init(scope);
    scope.querySelectorAll('[data-shf-footer]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
